import React from "react";
import { useForm, useWatch } from "react-hook-form";
import useFormActions from "../useFormActions";
import { EmailField } from "../../common/forms/components/EmailField";
import CheckboxField from "../../common/forms/components/CheckboxField";
import StepWrapper from "./StepWrapper";
import { checkboxIsRequired } from "../../common/forms/utils";
import { subscriptionStepProps } from "../../common/types/subscription";

export default function Step2({
	formStep,
	subtitle,
	title,
}: subscriptionStepProps) {
	const { onCheckIfUserExists, onUpdateField, onUpdateForm } =
		useFormActions();
	const { control, handleSubmit, setError, clearErrors } = useForm();

	const emailInput = useWatch({
		control,
		name: "email",
	});

	const handleUpdateForm = async (data) => {
		const { isDomainBlocked } = await onCheckIfUserExists(data.email);
		if (isDomainBlocked) {
			setError("email", {
				type: "custom",
				message:
					"ch-aviation is a B2B data service. Free trial access is available exclusively to verified companies and organizations. Please enter your company email address to continue — we are unable to process requests submitted with personal email domains such as Gmail, Yahoo, or Hotmail.",
			});
			return;
		}
		clearErrors("email");
		onUpdateForm(data);
	};

	return (
		<StepWrapper
			formStep={formStep}
			onSubmit={handleSubmit(handleUpdateForm)}
			title={title}
			subtitle={subtitle}
		>
			<div className="email-group flex gap-20">
				<div className="grid__col-12 grid__col-md-6">
					<EmailField
						control={control}
						id="email"
						label="E-Mail"
						name="email"
						onInputChange={onUpdateField}
						required
					/>
				</div>
				<div className="grid__col-12 grid__col-md-6">
					<EmailField
						control={control}
						id="emailRepeat"
						label="Repeat E-Mail"
						name="emailRepeat"
						onInputChange={onUpdateField}
						required
						validate={{
							match: (value) =>
								value && emailInput && value === emailInput,
						}}
					/>
				</div>
			</div>
			<CheckboxField
				control={control}
				name="termsAndConditionsAgreement"
				label={
					<>
						I have read the{" "}
						<a href="/portal/terms" target="_blank">
							general terms and conditions
						</a>{" "}
						and agree to them.
					</>
				}
				onInputChange={onUpdateField}
				required
				validate={{
					required: checkboxIsRequired,
				}}
			/>
			<CheckboxField
				control={control}
				name="consent"
				onInputChange={onUpdateField}
				label="I agree to be contacted by ch-aviation regarding product updates."
			/>
		</StepWrapper>
	);
}
